import IndexedDB from '@/helpers/IndexedDB.js';


const user = async () => {   
    const result = await IndexedDB.getAll("users");
    return result[0] || {"roleName": 'all'};
}

export { user };